var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15.541,
    viewBox: "0 0 17 15.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_1_",
    "data-name": "warning (1)",
    transform: "translate(0 -20.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34191",
    "data-name": "Group 34191",
    transform: "translate(0 20.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40326",
    "data-name": "Path 40326",
    d: "M219.1,333.382a.874.874,0,0,0,0,1.747.874.874,0,0,0,0-1.747Z",
    transform: "translate(-210.599 -322.461)",
    fill: "#ff3939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40327",
    "data-name": "Path 40327",
    d: "M16.586,34.9a2.983,2.983,0,0,0,.007-3.019L11.12,22.4a3.015,3.015,0,0,0-5.235,0L.406,31.887a3.027,3.027,0,0,0,2.621,4.536H13.958A3.009,3.009,0,0,0,16.586,34.9ZM15.4,34.214a1.651,1.651,0,0,1-1.443.835H3.023A1.629,1.629,0,0,1,1.6,34.231a1.654,1.654,0,0,1,0-1.667l5.48-9.484a1.646,1.646,0,0,1,2.859,0l5.476,9.484A1.632,1.632,0,0,1,15.4,34.214Z",
    transform: "translate(0 -20.882)",
    fill: "#ff3939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40328",
    "data-name": "Path 40328",
    d: "M218.4,157.2a.95.95,0,0,0-.674.954c.021.276.038.556.059.832.059,1.052.119,2.083.178,3.135a.64.64,0,0,0,.653.615.653.653,0,0,0,.653-.636c0-.217,0-.416.021-.636.038-.674.08-1.349.119-2.023.021-.437.059-.874.08-1.31a1.079,1.079,0,0,0-.08-.437A.876.876,0,0,0,218.4,157.2Z",
    transform: "translate(-210.116 -152.413)",
    fill: "#ff3939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.bb52239e5a2a67b42eb4a3b6e60e3df5.svg";
export { ForwardRef as ReactComponent };